import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

function AdminRoute({ children }) {
    const { user, loading } = useUser();
    const adminEmails = (process.env.REACT_APP_ADMIN_EMAILS || '')
        .split(',')
        .map((entry) => entry.trim().toLowerCase())
        .filter(Boolean);

    if (loading) {
        return (
            <div className="page unauthorized-page">
                <section className="panel unauthorized-panel">
                    <h1>Checking admin access…</h1>
                </section>
            </div>
        );
    }

    const isAdmin = Boolean(
        user && (user.admin || adminEmails.includes((user.email || '').toLowerCase()))
    );

    if (!isAdmin) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
}

export default AdminRoute;
